import { redirect } from 'react-router-dom'
import { urls } from '../../core/urls'
import { logout } from '../../core/auth'


export function loader() {
    logout()
    return redirect(urls.selectEnterPage)
}